import React from "react";
import { useMessageGetter } from "react-message-context";
import { inject, observer } from "mobx-react";
import { validateFinnishPostalCode } from "@op/opds.validate";
import {
  emptyError,
  invalidTextFieldError,
  isBlank,
  useUpdateIncluded,
} from "../../../utils/commonUtils";
import TextField from "./TextField";
import { POSTAL_CODE } from "../../../utils/enums";

const CustomerPostalCode = observer(({ FeedbackStore }) => {
  const key = "postalCode";
  const { feedback, updateError, updateValue, updateIncluded } = FeedbackStore;
  const postalCode = feedback.postalCode;
  const msgs = useMessageGetter("feedback.form.postalCode");

  // Update included property when customer info value changes
  useUpdateIncluded(key, feedback.customerInfo.value, updateIncluded);

  const handleOnChange = (value) => {
    updateError(key, false);
    updateValue(key, value);
  };

  const handleOnBlur = () => {
    if (isBlank(postalCode.value)) {
      updateError(key, emptyError(msgs));
    } else {
      const result = validateFinnishPostalCode(postalCode.value);
      updateError(key, !!result.code ? invalidTextFieldError(msgs) : false);
    }
  };

  return (
    <TextField
      fieldName={key}
      autocomplete={POSTAL_CODE}
      value={postalCode.value}
      error={postalCode.error}
      handleOnChange={handleOnChange}
      handleOnBlur={handleOnBlur}
      maxLength={5}
    />
  );
});

export default inject("FeedbackStore")(CustomerPostalCode);
